// extracted by mini-css-extract-plugin
export default {"price":"Money_price__2WTQT","red":"Money_red__5aCVQ"};